import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { attribute } from "../../Services/ShowModal/ShowModal";

// Models
export interface iSelection{id:number,label:string}
export interface addMaterialFields {
    name?: string,
    description?: string,
    serial_number?: string,
    is_priced?: number,
    attributes?: attribute[],
    selection?:iSelection
}

// Add material state
export interface addMaterialState {
    fields: addMaterialFields,
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean,
    materialsList:iSelection[]
}

const initialAddMaterialState: addMaterialState = {
    fields: {
        name: "",
        description: "",
        serial_number: "",
        is_priced: 0,
        attributes: []
    },
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false,
    materialsList:[]
}

// Users slice
export const addMaterialSlice = createSlice({
    name: 'add_material',
    initialState: initialAddMaterialState,
    reducers: {
        init: state => initialAddMaterialState,
        set: (state, { payload }: PayloadAction<addMaterialFields>) => {
            state.fields = { ...state.fields, ...payload }
        },
        setList:(state,{payload}:PayloadAction<iSelection[]>)=>{
            state.materialsList=payload
        },
        setItem: (state, { payload }: PayloadAction<iSelection>) => {
          state.fields = { ...state.fields, ...payload }
          let index = state.materialsList.findIndex(ele=>ele.id== payload.id)
          if(index >-1){

              state.materialsList[index]=payload
          }
          else {
            state.materialsList=[...state.materialsList,payload]
          }
           
        },
        setAll: (state, { payload }: PayloadAction<addMaterialFields>) => {
            state.fields = payload
        },
        setEditId: (state, { payload }: PayloadAction<number>) => {
            state.editId = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsSuccess: (state, { payload }: PayloadAction<boolean>) => {
            state.isSuccess = payload
        },
        setIsOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.isOpen = payload
        },
    }
})